var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneProffitSearchInformation } from '../../../../actions/ProffitSearchAction';
import { apiCreateProffitSearchFolder, apiUpdateProffitSearchFolder, } from '../../../../actions/ProffitSearchFolderAction';
import { apiDeleteSlideSelectAll } from '../../../../actions/ProffitSearchSelectAction';
import { notify, wrapDispatch, wrapNotifyError } from '../../../action';
/**
 * スライドページのフォルダ制御を制御するuse
 * @param proffitSearch
 * @param dispatch
 * @returns {{folders: unknown, onSubmitCreateFolder: ((function(*=): Promise<void>)|*), onClickSaveFolder: ((function(*=, *=): Promise<void>)|*)}}
 */
export const useSlideSearchCommonFolderUpdate = (proffitSearch, dispatch) => {
    /**
     * フォルダの保存ボタンクリック時の処理
     * @type {(function(*=, *=): Promise<void>)|*}
     */
    const onClickSaveFolder = useCallback((id, slides) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            // フォルダの保存
            yield wrapDispatch(dispatch, apiUpdateProffitSearchFolder(id, { slides }));
            // 選択状態を全削除
            yield wrapDispatch(dispatch, apiDeleteSlideSelectAll());
            // プロフィール情報を引き直す
            yield wrapDispatch(dispatch, apiGetOneProffitSearchInformation());
            notify('フォルダに保存しました');
        }));
    }), [dispatch]);
    /**
     * 新規フォルダを作成のイベント
     * @type {(function(*=): Promise<void>)|*}
     */
    const onSubmitCreateFolder = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            // フォルダの新規作成
            yield wrapDispatch(dispatch, apiCreateProffitSearchFolder(values));
            // 選択状態を全削除
            yield wrapDispatch(dispatch, apiDeleteSlideSelectAll());
            // プロフィール情報を引き直す
            yield wrapDispatch(dispatch, apiGetOneProffitSearchInformation());
            notify('フォルダを作成しました');
        }));
    }), [dispatch]);
    return {
        folders: proffitSearch.folders,
        onClickSaveFolder,
        onSubmitCreateFolder,
    };
};
export default useSlideSearchCommonFolderUpdate;
